// eslint-disable-next-line import/prefer-default-export
export const userProjectKey = (userId) => `user_${userId}_project`;

export const userSurveyKey = (userId) => `user_${userId}_survey`;

export const language = 'language';

export const surveyStandardizationCSVKey = (surveyId) => `standardization_csv_${surveyId}`;
